import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Link} from "react-router-dom";
import {push} from "react-router-redux";
import QuestionForm from "../../../common/question-form";

class LifeQuestions extends GameComponent {

    sendAnswer = (values, form) => {
        this.props.sendInput(this.getInstanceId(), { type: 'life_answer', answer: values })
    };

    render() {
        let answers = this.props.gameInstance.instance.answers;
        let questions = this.props.knowledgeQuestions.list
            .filter((question) => {
                return question.properties.category === 'co_zivot_dal';
            });

        let total_count = questions.length;
        questions = questions
            .map((question) => {
                return { ...question, answer: answers.find((answer) => { return answer.luduengine_knowledge_question_id === question.id && answer.properties.valid }) };
            })
            .filter((question) => {
                return question.answer;
            })
            .sort((questionA, questionB) => {
                if (questionA.answer.created_at < questionB.answer.created_at) return 1;
                if (questionA.answer.created_at > questionB.answer.created_at) return -1;
                return 0;
            })
            .map((question, index) => {
                return (
                    <div key={question.id}>
                        <hr/>
                        <p className='label'>Událost { index + 1 } / { total_count }</p>
                        <QuestionForm key={question.id} className='question' question={question} answer={question.answer} active={false} instanceId={this.getInstanceId()} />
                    </div>
                )
            });

        let life_question = this.getInstanceProperty('ROUND_2_LIFE_QUESTION');
        let question = life_question ? this.props.knowledgeQuestions.list.find((question) => { return question.id === life_question.id }) : null;

        let life_question_finished = this.getInstanceProperty('ROUND_2_COMPLETED_LIFE');
        let round_2_completed = this.getInstanceProperty('ROUND_2_COMPLETED');

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <div className='separate-bottom'>
                            <h1 className='page-title-minor separate-bottom'>Co život dal</h1>
                            <p>Život na nás přichystá spoustu událostí, které nečekáme a neplánujeme. Co si vymyslel na vás?</p>
                        </div>
                        { question &&
                        <div className='separate-bottom'>
                            <p className='label'>Aktuální úkol</p>
                            {question && <QuestionForm key={question.id} className='question' question={question}
                                                       handleSubmit={this.sendAnswer}
                                                       active={this.isCurrentNodeType('Nodes::Round02Node')}
                                                       instanceId={this.getInstanceId()}/>}
                        </div>
                        }
                        {
                            life_question_finished && !round_2_completed &&
                            <div className='separate'>
                                <p>Úspěšně jste dokončili úkoly "Co život dal". Nyní můžete ukončit kolo.</p>
                                <Link to={`/game/${this.getInstanceId()}/round-2/finalize`} className='btn btn-primary'>Ukončit kolo</Link>
                            </div>
                        }
                        <p className='label'>Hotové úkoly</p>
                        { questions }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LifeQuestions);
